import Loading, { LoadingBall } from '@ingka/loading';
import { ReactNode } from 'react';

import Modal, { ModalBody, ModalHeader, SheetSize, Sheets } from '../Skapa/Modal/Modal';
import { PREFIX } from '../Skapa/constants/constants';
import styles from './LoginModal/LoginModal.module.scss';
import classNames from 'classnames';

export const Wrapper = ({
  children,
  visible,
  loading,
  title,
  noPadding,
  close,
  back,
}: {
  children?: ReactNode;
  loading?: boolean;
  visible: boolean;
  noPadding?: boolean;
  title?: string;
  close: () => void;
  back?: () => void;
}) => (
  <Modal onModalClosed={close} prefix={PREFIX} className="menuModal" visible={visible} handleCloseBtn={close}>
    <Sheets
      prefix={PREFIX}
      className="menuSheetsModal"
      header={<ModalHeader backBtnClick={back} title={title} />}
      size={SheetSize.SMALL}
      footer={null}
      preserveAlignment
    >
      <ModalBody prefix={PREFIX} className={classNames(styles.skapasModalBody, { [styles.noPadding]: noPadding })}>
        <div className={styles.menuModalBodyContainer}>
          {!!loading && (
            <Loading prefix={PREFIX} text="">
              <LoadingBall prefix={PREFIX} />
            </Loading>
          )}
          {children}
        </div>
      </ModalBody>
    </Sheets>
  </Modal>
);
